export function getURLFromStoryblokLink(link: { cached_url: string; url: string }) {
  if (!link) return;
  if (link?.cached_url !== '') {
    return link?.cached_url;
  }
  if (link?.url !== '') {
    return link?.url;
  }
}
